export const FLOATING_FORMATTING_TOOLBAR = 'floating-formatting-toolbar';
export const FORMATTING_TOOLBAR = 'ricos-formatting-toolbar';
